import clsx from "clsx";
import { snakeCase } from "lodash";
import Icon from "./Icon";
import { IGridActionIcons } from "./@types";
import TooltipIcon from "./TooltipIcon";

const GridActionIcons = ({ items }: { items: IGridActionIcons[] }) => (
  <div className="grid-action-icons">
    {items.map(item => {
      const {
        name,
        iconName,
        disabled = false,
        onClick,
        className,
        message = ""
      } = item || {};
      const iconClassName = clsx(
        "grid-action-icons__icon",
        className,
        disabled && "disabled"
      );
      return disabled ? (
        <TooltipIcon
          icon={iconName}
          className={iconClassName}
          message={message}
          key={iconName}
        />
      ) : (
        <Icon
          name={iconName}
          className={iconClassName}
          onClick={onClick}
          key={iconName}
          data-testid={snakeCase(`grid_action_icon_${name}`)}
        />
      );
    })}
  </div>
);

export default GridActionIcons;
